import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import Vue from 'vue';
import get from 'lodash/get.js';
import isBoolean from 'lodash/isBoolean.js';
import isEqual from 'lodash/isEqual.js';
import LoadingComponent from './components/loading.vue.js';

const Loader = Vue.extend(LoadingComponent);
const LOADING_DEFAULTS = {
  type: 'skeleton',
  textClass: 'pendo-loading-text',
  overlayProps: {
    class: 'pendo-loading-overlay',
    transition: 'pendo-loading-fade'
  },
  spinnerProps: {
    class: 'pendo-loading-spinner',
    color: '#2a2c35',
    background: '#f4f4f7',
    size: 24
  },
  skeletonProps: {
    class: 'pendo-loading-skeleton',
    speed: 2,
    borderRadius: 3,
    animate: true,
    primaryColor: '#eaecf1',
    secondaryColor: '#f8f8f9'
  }
};
function getOptions(options) {
  return {
    type: options.type || PendoLoading.options.type,
    text: options.text || PendoLoading.options.text,
    textClass: options.textClass || PendoLoading.options.textClass,
    preventRelativeParent: options.preventRelativeParent || PendoLoading.options.preventRelativeParent,
    overlayProps: _objectSpread2(_objectSpread2({}, PendoLoading.options.overlayProps), options.overlayProps),
    spinnerProps: _objectSpread2(_objectSpread2({}, PendoLoading.options.spinnerProps), options.spinnerProps),
    skeletonProps: _objectSpread2(_objectSpread2({}, PendoLoading.options.skeletonProps), options.skeletonProps)
  };
}
function getLoadingValue(value) {
  if (isBoolean(value)) {
    return value;
  }
  if (value && typeof value === 'object') {
    return value.loading;
  }
  return false;
}
function insertDom(el) {
  if (!el.domVisible && el.style.display !== 'none' && el.style.visibility !== 'hidden') {
    if (!['absolute', 'fixed'].includes(el.originalPosition) && !el.instance.preventRelativeParent) {
      el.classList.add('pendo-loading-parent--relative');
    }
    el.domVisible = true;
    el.appendChild(el.mask);
    el.instance.visible = true;
    el.domInserted = true;
  } else if (el.domVisible && el.instance.hiding === true) {
    el.instance.visible = true;
    el.instance.hiding = false;
  }
}
function toggleLoading(el, _ref) {
  let {
    value
  } = _ref;
  if (value) {
    el.originalPosition = el.style.position;
    insertDom(el);
  } else {
    el.instance.visible = false;
    el.instance.hiding = true;
    const unwatch = el.instance.$watch('hiding', () => {
      if (!el.instance.hiding) {
        el.domVisible = false;
        el.classList.remove('pendo-loading-parent--relative');
        unwatch();
      }
    });
  }
}
function createLoader(el, _ref2) {
  let {
    arg,
    value
  } = _ref2;
  const data = _objectSpread2({}, getOptions(_objectSpread2({
    type: arg || 'skeleton'
  }, value)));
  const loader = new Loader({
    el: document.createElement('div'),
    data
  });
  el.instance = loader;
  el.mask = loader.$el;
  return el;
}
function bind(el, _ref3) {
  let {
    arg,
    value
  } = _ref3;
  const isLoading = getLoadingValue(value);
  const loader = createLoader(el, {
    arg,
    value
  });
  if (isLoading) {
    toggleLoading(loader, {
      value: true
    });
  }
}
function setContainerSize(_ref4) {
  let {
    el
  } = _ref4;
  requestAnimationFrame(() => {
    let height = el.clientHeight;
    let width = el.clientWidth;
    if (el.instance.type === 'skeleton') {
      height = get(el.instance, 'skeletonProps.height', el.parentElement ? el.parentElement.clientHeight : el.clientHeight);
      width = get(el.instance, 'skeletonProps.width', el.parentElement ? el.parentElement.clientWidth : el.clientWidth);
    }
    el.instance.setContainerSize({
      height,
      width
    });
  });
}
function inserted(el, _ref5) {
  let {
    value
  } = _ref5;
  const currentValue = getLoadingValue(value);
  if (currentValue) {
    setContainerSize({
      el
    });
  }
}
function update(el, _ref6) {
  let {
    oldValue,
    value
  } = _ref6;
  if (isEqual(oldValue, value)) {
    return;
  }
  const currentValue = getLoadingValue(value);
  if (currentValue) {
    setContainerSize({
      el
    });
  }
  return toggleLoading(el, {
    value: currentValue
  });
}
function unbind(el) {
  if (el.domInserted) {
    if (el.mask && el.mask.parentNode) {
      el.mask.parentNode.removeChild(el.mask);
    }
    toggleLoading(el, {
      value: false
    });
  }
  if (el.instance) {
    el.instance.$destroy();
  }
}
const PendoLoading = {
  options: LOADING_DEFAULTS,
  bind,
  inserted,
  update,
  unbind
};
var PendoLoading$1 = PendoLoading;

export { LOADING_DEFAULTS, PendoLoading, bind, createLoader, PendoLoading$1 as default, getLoadingValue, getOptions, insertDom, inserted, toggleLoading, unbind, update };
//# sourceMappingURL=pendo-loading.js.map
